import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Content, type BuilderContent } from '@builder.io/sdk-angular';
import { BuilderService } from '../../services/builder.service';

/**
 * BlogSymbolSectionComponent
 * 
 * Renders specific symbol entries (header/footer) from Builder.io
 * Follows Builder.io Gen2 SDK best practices for fetching and rendering symbols
 */
@Component({
  selector: 'app-blog-symbol-section',
  templateUrl: './blog-symbol-section.component.html',
  styleUrls: ['./blog-symbol-section.component.scss'],
  standalone: true,
  imports: [CommonModule, Content]
})
export class BlogSymbolSectionComponent implements OnInit {
  @Input() apiKey!: string;
  @Input() entryName!: string;
  @Input() position: 'header' | 'footer' = 'header';
  
  model = 'symbol';
  symbolContent: BuilderContent | null = null;
  loading = true;
  
  constructor(private builderService: BuilderService) {}
  
  ngOnInit() {
    this.fetchSymbolEntry();
  }

  /**
   * Fetches symbol entry by name from Builder.io
   * Uses Gen2 SDK fetchEntries with client-side filtering for reliability
   */
  private async fetchSymbolEntry() {
    if (!this.entryName) {
      console.error('BlogSymbolSection: entryName is required');
      this.loading = false;
      return;
    }

    this.loading = true;
    
    try {
      // Fetch all published symbols (Gen2 SDK best practice)
      const symbols = await this.builderService.getMultipleContent(this.model, {
        limit: 100,
        options: {
          noTargeting: true
        }
      });

      // Find symbol by name (case-insensitive and trimmed for robustness)
      const symbol = symbols.find(s => 
        s.name && s.name.trim().toLowerCase() === this.entryName.trim().toLowerCase()
      );
      
      // Only display if found and published
      if (symbol && symbol.published === 'published') {
        this.symbolContent = symbol;
      } else if (symbol) {
        console.warn(`BlogSymbolSection: Symbol "${this.entryName}" exists but is not published`);
      } else {
        console.warn(`BlogSymbolSection: Symbol "${this.entryName}" not found`);
      }
      
    } catch (error) {
      console.error(`BlogSymbolSection: Error fetching symbol "${this.entryName}":`, error);
      this.symbolContent = null;
    } finally {
      this.loading = false;
    }
  }
}

